(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-gallery-thumb]');
    if (!thumbnail) return;
    const gallery = thumbnail.closest('[data-product-gallery]');
    const target = gallery && gallery.querySelector('#' + thumbnail.dataset.mediaTarget);
    if (!target) return;
    gallery.querySelectorAll('[data-gallery-slide]').forEach((slide) => {
      if (slide !== target) slide.querySelectorAll('video').forEach((video) => video.pause());
      slide.hidden = slide !== target;
    });
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => { button.setAttribute('aria-current', String(button === thumbnail)); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quiz"] && !Shopify.designMode) return;
  try {
    
function initFitQuiz(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('[data-fit-quiz]'),result=root.querySelector('[data-result]');
 const sync=()=>{const shape=form.elements.goal.value==='shape';root.querySelector('[data-shape]').hidden=!shape;root.querySelector('[data-waist]').hidden=shape;form.elements.shape.disabled=!shape;form.elements.waist.disabled=shape;result.hidden=true;};
 form.addEventListener('change',sync);
 form.addEventListener('submit',e=>{e.preventDefault();const key=form.elements.goal.value==='shape'?form.elements.shape.value:form.elements.waist.value;const source=root.querySelector('template[data-match="'+key+'"]');const card=root.querySelector('[data-result-card]');card.replaceChildren(source.content.cloneNode(true));root.querySelector('[data-new]').hidden=form.elements.experience.value!=='new';root.querySelector('[data-familiar]').hidden=form.elements.experience.value==='new';result.hidden=false;result.focus();});
 root.querySelector('[data-reset]').addEventListener('click',()=>{form.reset();sync();form.elements.goal.focus();});
 sync();
}
document.querySelectorAll('.product-quiz').forEach(initFitQuiz);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.product-quiz').forEach(initFitQuiz));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snatch-squad"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('snatch-product-carousel')) {
customElements.define('snatch-product-carousel', class extends HTMLElement {
connectedCallback() {
const track=this.querySelector('.squad-products__track');
const originals=Array.from(track.children);
const toggle=this.querySelector('[data-autoplay]');
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
let paused=reduced.matches, hovered=false, visible=false, cycle=0, position=0, last=0;
const update=()=>{toggle.textContent=paused?this.dataset.play:this.dataset.pause;toggle.setAttribute('aria-pressed',String(paused));};
originals.forEach(card=>{const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.setAttribute('tabindex','-1');clone.dataset.clone='';track.appendChild(clone);});
const measure=()=>{cycle=originals.length*(originals[0].getBoundingClientRect().width+16);position=track.scrollLeft;};
this.resizeObserver=new ResizeObserver(measure);this.resizeObserver.observe(track);
const step=(direction)=>{const distance=originals[0].getBoundingClientRect().width+16;if(direction<0&&track.scrollLeft<1)track.scrollLeft=cycle;track.scrollBy({left:distance*direction,behavior:reduced.matches?'instant':'smooth'});};
this.observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;});this.observer.observe(this);
toggle.addEventListener('click',()=>{paused=!paused;position=track.scrollLeft;update();});
this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{paused=true;update();step(Number(button.dataset.direction));}));
track.addEventListener('pointerdown',()=>{paused=true;update();});
track.addEventListener('keydown',()=>{paused=true;update();});
track.addEventListener('wheel',()=>{paused=true;update();},{passive:true});
track.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')hovered=true;});
track.addEventListener('pointerleave',()=>{hovered=false;});
track.addEventListener('scroll',()=>{if(paused||hovered)position=track.scrollLeft;},{passive:true});
reduced.addEventListener('change',this.onMotionChange=()=>{paused=reduced.matches;update();});
const tick=now=>{const delta=last?Math.min(now-last,1000):0;last=now;if(visible&&!paused&&!hovered&&!document.hidden&&cycle){position+=delta*.04;if(position>=cycle)position-=cycle;track.scrollLeft=position;}this.frame=requestAnimationFrame(tick);};
measure();update();this.frame=requestAnimationFrame(tick);
}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.resizeObserver?.disconnect();matchMedia('(prefers-reduced-motion: reduce)').removeEventListener('change',this.onMotionChange);this.querySelectorAll('[data-clone]').forEach(card=>card.remove());}
});
}
if (!customElements.get('snatch-gallery')) {
customElements.define('snatch-gallery', class extends HTMLElement {
connectedCallback() {
const track = this.querySelector('.squad-track');
const originals = Array.from(track.children);
const toggle = this.querySelector('[data-toggle]');
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
this.abort = new AbortController();
const signal = this.abort.signal;
let paused = reduced.matches, hovered = false, visible = false, cycle = 0, position = 0, last = 0, manualUntil = 0;
const update = () => { toggle.textContent = paused ? this.dataset.play : this.dataset.pause; toggle.setAttribute('aria-pressed', String(paused)); };
originals.forEach(slide => { const clone = slide.cloneNode(true); clone.setAttribute('aria-hidden','true'); clone.removeAttribute('data-shopify-editor-block'); clone.dataset.clone = ''; track.appendChild(clone); });
const measure = () => { cycle = originals.length * (originals[0].getBoundingClientRect().width + 20); position = track.scrollLeft; };
this.resizeObserver = new ResizeObserver(measure); this.resizeObserver.observe(track);
toggle.addEventListener('click', () => { paused = !paused; update(); }, {signal});
track.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse') hovered = true; }, {signal});
track.addEventListener('pointerleave', () => { hovered = false; }, {signal});
track.addEventListener('pointerdown', () => { paused = true; update(); }, {signal});
track.addEventListener('keydown', () => { paused = true; update(); }, {signal});
track.addEventListener('wheel', () => { paused = true; update(); }, {signal,passive:true});
this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
paused = true; update(); manualUntil = performance.now() + 800;
if(Number(button.dataset.step) < 0 && track.scrollLeft < 1) track.scrollLeft = cycle;
track.scrollBy({left:(originals[0].getBoundingClientRect().width + 20) * Number(button.dataset.step), behavior:reduced.matches ? 'instant' : 'smooth'});
}, {signal}));
track.addEventListener('scroll', () => {
if(cycle && track.scrollLeft >= cycle && performance.now() > manualUntil) track.scrollLeft -= cycle;
if(paused || hovered) position = track.scrollLeft;
}, {signal,passive:true});
reduced.addEventListener('change', () => { paused = reduced.matches; update(); }, {signal});
this.observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;}); this.observer.observe(this);
const tick = now => {
const delta = Math.min(now - last, 50); last = now;
if(visible && !paused && !hovered && !document.hidden && !track.matches(':focus-visible') && cycle) {
position += delta * 0.024;
if(position >= cycle) position -= cycle;
track.scrollLeft = position;
}
this.frame = requestAnimationFrame(tick);
};
measure(); update(); this.frame = requestAnimationFrame(tick);
}
disconnectedCallback() { cancelAnimationFrame(this.frame); this.abort?.abort(); this.resizeObserver?.disconnect(); this.observer?.disconnect(); this.querySelectorAll('[data-clone]').forEach(el=>el.remove()); }
});
}
if (!customElements.get('snatch-review-viewer')) {
customElements.define('snatch-review-viewer', class extends HTMLElement {
connectedCallback() {
const dialog=this.querySelector('dialog');
const slides=Array.from(this.querySelectorAll('[data-review-slide]'));
if(!dialog || !slides.length) return;
this.abort=new AbortController();
const signal=this.abort.signal;
let current=0, opener=null, touchX=null;
const counter=this.querySelector('[data-review-count]');
const show=index=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==current;});counter.textContent=`${current+1} / ${slides.length}`;};
this.querySelectorAll('[data-review-open]').forEach(button=>button.addEventListener('click',()=>{opener=button;show(Number(button.dataset.reviewOpen));dialog.showModal();this.querySelector('[data-review-close]').focus();},{signal}));
this.querySelector('[data-review-close]').addEventListener('click',()=>dialog.close(),{signal});
this.querySelectorAll('[data-review-step]').forEach(button=>button.addEventListener('click',()=>show(current+Number(button.dataset.reviewStep)),{signal}));
dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();},{signal});
dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();show(current+(event.key==='ArrowRight'?1:-1));}},{signal});
dialog.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].clientX;},{signal,passive:true});
dialog.addEventListener('touchend',event=>{if(touchX===null)return;const delta=event.changedTouches[0].clientX-touchX;touchX=null;if(Math.abs(delta)>45)show(current+(delta<0?1:-1));},{signal,passive:true});
dialog.addEventListener('close',()=>{opener?.focus();},{signal});
}
disconnectedCallback(){this.abort?.abort();}
});
}

  } catch(e) { console.error(e); }
})();
})();
